import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Header } from '../DataBox.styles';

export default function DataBoxHeader({ children, testId = 'data-box-header' }: IDataBox) {
  return <Header data-testid={testId}>{children}</Header>;
}
